import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Jobs from "@/pages/Jobs";
import NewJob from "@/pages/NewJob";
import JobDetail from "@/pages/JobDetail";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Team from "@/pages/Team";
import CalendarPage from "@/pages/Calendar";
import PriceBook from "@/pages/PriceBook";
import Estimates from "@/pages/Estimates";
import NewEstimate from "@/pages/NewEstimate";
import EstimateDetail from "@/pages/EstimateDetail";
import SettingsPayments from "@/pages/SettingsPayments";
import SettingsBilling from "@/pages/SettingsBilling";
import AdminOverview from "@/pages/AdminOverview";
import AdminCompany from "@/pages/AdminCompany";
import AdminCoupons from "@/pages/AdminCoupons";
import PublicEstimate from "@/pages/PublicEstimate";
import PublicInvoice from "@/pages/PublicInvoice";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            {/* Public (no auth) — customer-facing links */}
            <Route path="/estimate/:token" element={<PublicEstimate />} />
            <Route path="/invoice/:token" element={<PublicInvoice />} />
            {/* Founder admin — separate layout, adminOnly */}
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminOverview /></ProtectedRoute>} />
            <Route path="/admin/coupons" element={<ProtectedRoute adminOnly><AdminCoupons /></ProtectedRoute>} />
            <Route path="/admin/companies/:id" element={<ProtectedRoute adminOnly><AdminCompany /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/new" element={<NewJob />} />
              <Route path="/jobs/:id" element={<JobDetail />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/estimates" element={<Estimates />} />
              <Route path="/estimates/new" element={<NewEstimate />} />
              <Route path="/estimates/:id" element={<EstimateDetail />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/invoices/:id" element={<InvoiceDetail />} />
              <Route path="/price-book" element={<PriceBook />} />
              <Route path="/team" element={<Team />} />
              <Route path="/settings/payments" element={<SettingsPayments />} />
              <Route path="/settings/billing" element={<SettingsBilling />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors duration={4000} closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
